import React from "react";
import { useSelector } from "react-redux";
import SearchFields from "./searchFields";
import SearchTable from "./searchTable";
import ProgramHomePage from "./programHomePage";

import "./style.scss";

const ProgramBuilder = () => {
  const { showProgramSearchTable } = useSelector((state) => state.programBuilder);

  return (
    <React.Fragment>
      <SearchFields />
      {showProgramSearchTable && <SearchTable />}
      {/* <ProgramHomePage/> */}
    </React.Fragment>
  );
};

export default ProgramBuilder;
